import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const tracingLocationAdapter = getAdapter();

const tracingLocationSlice = createSlice({
  name: 'tracingLocations',
  initialState: tracingLocationAdapter.getInitialState(),
  reducers: {
    setTracingLocation: (state, { payload: { locations } }) => {
      tracingLocationAdapter.setAll(state, locations);
    },
  },
});

const selectors = tracingLocationAdapter.getSelectors(({ locations }) => locations);

export const getTracingLocations = (state) => selectors.selectAll(state);

export const { setTracingLocation } = tracingLocationSlice.actions;

export default tracingLocationSlice.reducer;
